import axios from "axios";
//const vacanciesUrl = "https://recruiter-api.hr-manager.net/jobportal.svc/telemark_vestfold/positionlist/json/";
const vacanciesUrl = "https://recruiter-api.hr-manager.net/jobportal.svc/vestfoldtelemark/positionlist/json/?take=100";

// Delete existing result items
const deleteResultItems = () => {
    let vacanciesResultsContainer = document.querySelector(".vacancies-results");
    while (vacanciesResultsContainer.firstChild) {
        vacanciesResultsContainer.removeChild(vacanciesResultsContainer.firstChild);
    }
};

const createResultItems = items => {

    let resultAmountElement = document.querySelector(".result-amount");
    resultAmountElement.removeChild(resultAmountElement.firstChild);
    resultAmountElement.appendChild(document.createTextNode(items.length));


    items.forEach(item => {
        // let nullCheckBusiness = "";
        // // null checks before passing to function
        // if (item.PositionLocation)
        //     nullCheckBusiness = item.PositionLocation.Name;
        // let nullCheckVacanciesSize =  "" ;
        // // null checks before passing to function
        // if (item.CustomList5MultiSelection[0])
        // nullCheckVacanciesSize = item.CustomList5MultiSelection[0].Name;

        let nullCheckMunicipality = "";
        // null checks before passing to function
        if (item.CustomList3)
            nullCheckMunicipality = item.CustomList3.Name;


        createResultItem(
            item.Name,
            item.AdvertisementUrlSecure,
            // nullCheckBusiness,
            item.Department.Name,
            // nullCheckVacanciesSize,
            nullCheckMunicipality,
            item.ApplicationDue);
    });
};

// Create result items
const createResultItem = (title, link, business, employmentType, deadline) => {

    // Create date object of deadline 
    let vacanciesDeadline = new Date(deadline.match(/\d+/)[0] * 1);
    let vacanciesDeadlineShort = vacanciesDeadline.toLocaleDateString("nb-NO");

    // Create new DOM elements
    let vacanciesResultsContainer = document.querySelector(".vacancies-results");
    let vacanciesResultWrapper = document.createElement("div");
    vacanciesResultWrapper.classList.add("col-12", "mb-3");
    let vacanciesResult = document.createElement("div");
    vacanciesResult.classList.add("vacancies-result", "px-10", "pb-3");
    let vacanciesResultHeader = document.createElement("h2");
    vacanciesResultHeader.classList.add("font-size--17");
    let vacanciesResultLink = document.createElement("a");
    vacanciesResultLink.setAttribute("target", "_blank");
    vacanciesResultLink.setAttribute("rel", "noreferrer  noopener");
    let vacanciesResultBusiness = document.createElement("p");
    vacanciesResultBusiness.classList.add("mb-1");
    let vacanciesResultEmploymentType = document.createElement("p");
    vacanciesResultEmploymentType.classList.add("mb-1");
    let vacanciesResultDeadline = document.createElement("p");
    vacanciesResultDeadline.classList.add("mb-1");

    // Add values to elements
    vacanciesResultLink.href = link;
    vacanciesResultBusiness.appendChild(document.createTextNode(business));
    vacanciesResultEmploymentType.appendChild(document.createTextNode(employmentType));
    vacanciesResultDeadline.appendChild(document.createTextNode("Søknadsfrist: " + vacanciesDeadlineShort));
    vacanciesResultLink.appendChild(document.createTextNode(title));

    // Insert them into result container
    vacanciesResultHeader.appendChild(vacanciesResultLink);
    vacanciesResult.appendChild(vacanciesResultHeader);
    vacanciesResult.appendChild(vacanciesResultBusiness);
    vacanciesResult.appendChild(vacanciesResultEmploymentType);
    vacanciesResult.appendChild(vacanciesResultDeadline);
    vacanciesResultsContainer.appendChild(vacanciesResultWrapper);
    vacanciesResultWrapper.appendChild(vacanciesResult);
};

const createSelectOptions = (select, options) => {
    let selectElement = document.querySelector(select);

    options.forEach(option => {
        let optionElement = document.createElement("option");
        optionElement.value = option;
        optionElement.innerHTML = option;
        selectElement.appendChild(optionElement);
    });

};

const filterResults = items => {

    // Remove old results
    deleteResultItems();

    // Create a clone of the original data object so that we don't manipulate the source
    let dataClone = JSON.parse(JSON.stringify(items));


    let countySelectElement = document.getElementById("vacancies__filtration--municipality");
    let county = countySelectElement.value;
    let businessSelectElement = document.getElementById("vacancies__filtration--business");
    let business = businessSelectElement.options[businessSelectElement.selectedIndex].value;
    let categorySelectElement = document.getElementById("vacancies__filtration--category");
    let category = categorySelectElement.options[categorySelectElement.selectedIndex].value;

    let newItems = dataClone.filter(item => {
        if (county && item.CustomList3 && county !== item.CustomList3.Name)
            return false;

        if (category && item.CustomList1 && category !== item.CustomList1.Name)
            return false;

        if (business && item.CustomList2 && business !== item.CustomList2.Name)
            return false;

        return true;
    });

    createResultItems(newItems);
};

const searchResults = items => {

    // Remove old results
    deleteResultItems();

    // Create a clone of the original data object so that we don't manipulate the source
    let dataClone = JSON.parse(JSON.stringify(items));

    let searchInput = document.querySelector(".vacancies__search__input");
    let searchInputValue = searchInput.value;

    let newItems = dataClone.filter(item => {

        if (item.Name.toLowerCase().includes(searchInputValue.toLowerCase())) {
            return true;
        }
        return false;
    });

    filterResults(newItems);

};
const resetresults = items => {
    // Remove old results
    deleteResultItems();

    // Create a clone of the original data object so that we don't manipulate the source
    let dataClone = JSON.parse(JSON.stringify(items));

    createResultItems(dataClone);


    let countySelectElement = document.getElementById("vacancies__filtration--municipality");
    let businessSelectElement = document.getElementById("vacancies__filtration--business");
    let categorySelectElement = document.getElementById("vacancies__filtration--category");
    let searchInput = document.querySelector(".vacancies__search__input");

    countySelectElement.selectedIndex = 0;
    businessSelectElement.selectedIndex = 0;
    categorySelectElement.selectedIndex = 0;
    searchInput.value = "";

};

document.addEventListener('DOMContentLoaded', function() {


    let hasVacanciesFilterModule = document.querySelector(".vacancies");

    if (hasVacanciesFilterModule) {

        axios.get(vacanciesUrl).then(function(response) {
            
            //Sorting items with upcomming ApplicationDue first.  
            response.data.Items.sort(function (a,b) {
                return new Date(a.ApplicationDue.match(/\d+/)[0] * 1) - new Date(b.ApplicationDue.match(/\d+/)[0] * 1);
            });
            
            const data = response.data;
            // console.log("We have data: ", data);

            document.querySelector(".result-amount").appendChild(document.createTextNode(data.Items.length));

            // ... 
            let countySelectElement = "#vacancies__filtration--municipality";
            let businessSelectElement = "#vacancies__filtration--business";
            let categorySelectElement = "#vacancies__filtration--category";
            let countyOptions = [];
            let businessOptions = [];
            let categoryOptions = [];
            let business = "";

            data.Items.forEach(item => {
                if (item.CustomList3 && item.CustomList3.Name && !countyOptions.includes(item.CustomList3.Name))
                    countyOptions.push(item.CustomList3.Name);

                if (item.CustomList2 && item.CustomList2.Name && !businessOptions.includes(item.CustomList2.Name))
                    businessOptions.push(item.CustomList2.Name);

                if (item.CustomList1 && item.CustomList1.Name && !categoryOptions.includes(item.CustomList1.Name))
                    categoryOptions.push(item.CustomList1.Name);
            });

            createResultItems(data.Items);

            // 
            createSelectOptions(countySelectElement, countyOptions);
            createSelectOptions(businessSelectElement, businessOptions);
            createSelectOptions(categorySelectElement, categoryOptions);
            // filtering vacancies by the help of select
            const filtratingEventListener = (select) => {
                let selectElement = document.querySelector(select);
                selectElement.addEventListener("change", event => {
                    // console.log("A select changed value to : ", event.target.value);
                    // console.log("Select event ", event);
                    // A select changed, lets filter results based on current selections
                    filterResults(data.Items);
                });
            };
            filtratingEventListener(countySelectElement);
            filtratingEventListener(businessSelectElement);
            filtratingEventListener(categorySelectElement);

            // search input event listener
            let searchButton = document.querySelector(".vacancies__search-button");
            searchButton.addEventListener("click", event => {
                searchResults(data.Items);
            });

            let searchInput = document.querySelector(".vacancies__search__input");
            searchInput.addEventListener("keyup", event => {
                if (event.key == "Enter")
                    searchResults(data.Items);

            });

            let resetButton = document.querySelector(".vacancies__filter--reset__button");

            resetButton.addEventListener("click", event => {
                // console.log("reset has been clicked ", data.Items);
                resetresults(data.Items);
            });
        }).catch(function(error) {
            console.log("Unable to fetch vacancies", error);

        }).finally(function() {
            // Remove loader here
            document.querySelector(".vacancies__spinner").classList.remove("d-flex");
            document.querySelector(".vacancies__spinner").classList.add("d-none");
        });
    }
});
